import { FC, useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LastRouteContext } from 'RoutePreserver/lastRouteProvider';

interface PublicRouteProps {
  isAuthenticated: boolean;
  isLoading: boolean;
  restricted: boolean;
}

const PublicRoute: FC<PublicRouteProps> = (
  {
    isAuthenticated,
    isLoading,
    restricted
  }
) => {
  const { lastRoute } = useContext(LastRouteContext);

  if (isLoading) {
    return <div>L O A D I N G...</div>;
  }

  if (isAuthenticated && restricted) {
    if (lastRoute) {
      console.log('Detected previously used route, loading:', lastRoute);
      return <Navigate to={lastRoute} />;
    } else {
      console.log('Loading default route');
      return <Navigate to={'/context'} />;
    }
  }

  return <Outlet />
};

export default PublicRoute;
